import React from "react";
import LeftSideBar from "./Sidebar";
import NavBar from "../../../Common/NavBar";

const AdminLayout = ({ children }) => {
  return (
    <div className="max-md:w-screen">
      <NavBar />
      <div
        className="grid items-start w-full min-h-screen pt-14 bg-white"
        style={{
          gridTemplateColumns: "var(--admin-sidebar-width, 4rem) 1fr",
          transition: "grid-template-columns 0.3s ease",
        }}
      >
        <LeftSideBar />
        <main
          className="w-full min-h-screen bg-white max-md:max-w-[90%]"
          style={{
            width: "100%",
            minWidth: 0,
          }}
        >
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
